import { getLocalizedValue, getLocalizedValues } from './get-localized-value.js';
import { isPlainObject, isPresent } from './type-guards.js';

const findAttribute = (input, attrName)=>input && input.attributes ? input.attributes.find((attr)=>attr.name === attrName
    ) : undefined
;
const getAttrValue = (input, attrName)=>{
    const attr = findAttribute(input, attrName);
    // CT Enum has a definition of key and label inside value
    if (isPlainObject(attr) && attr.value && attr.value.hasOwnProperty('key') && attr.value.hasOwnProperty('label')) {
        return attr.value.label;
    }
    return attr && attr.value;
};
const getLocalizedAttrValue = (input, attrName, locale)=>{
    const attr = getAttrValue(input, attrName);
    if (!isPlainObject(attr)) {
        return '';
    }
    return getLocalizedValue(attr, locale);
};
const getLocalizedAttrValues = (input, attrName, locale)=>{
    const attr = getAttrValue(input, attrName);
    if (!Array.isArray(attr)) {
        return [];
    }
    return getLocalizedValues(attr, locale);
};
/**
 * If attribute is an array, return it joined by the separator, otherwise just the string.
 */ const getJoinedLocalizedAttrValues = (input, attrName, locale, separator = ', ')=>{
    const attr = getAttrValue(input, attrName);
    if (isPlainObject(attr)) {
        return getLocalizedValue(attr, locale);
    }
    if (Array.isArray(attr)) {
        var ref;
        var ref1;
        return (ref1 = (ref = getLocalizedValues(attr, locale)) === null || ref === void 0 ? void 0 : ref.join(separator)) !== null && ref1 !== void 0 ? ref1 : '';
    }
    return '';
};
const getStringAttrValue = (input, attrName)=>{
    const value = getAttrValue(input, attrName);
    if (isPresent(value) && typeof value === 'string') {
        return value;
    }
    return undefined;
};

export { getAttrValue, getJoinedLocalizedAttrValues, getLocalizedAttrValue, getLocalizedAttrValues, getStringAttrValue };
//# sourceMappingURL=get-attribute.js.map
